const notEmptyRule = (value) => {
  if ((value && value.toString().trim()) || value === 0) {
    return true;
  }
  return "Field must not be empty.";
};

const integersRule = (value) => {
  if (!value || !value.toString().trim()) return true;
  if (!/^([1-9]\d*|0)$/.test(value)) {
    return "Only integers are allowed";
  }
  if (!isNaN(value) && value === parseInt(value)) return true;
  return "Only integers are allowed";
};

const dnsOverrideRule = (value) => {
  const pattern = new RegExp(/\w+\.\w+\s\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/gi);
  if (!!pattern.test(value) || !value) {
    return true;
  } else {
    return "Invalid DNS Override (<url> <ip>)";
  }
};

const uniqueValue = (value) => {
  // This function checks if the value is a unique value, same value can not be entered twice
  if (value && Array.isArray(value)) {
    const uniqueValues = new Set(value.map((x) => x.toLowerCase()));
    if (uniqueValues.size !== value.length) {
      return "Value should be unique.";
    }
    return true;
  }
}

const nonNumberUrlRule = (value) => {
  const pattern = new RegExp("[a-zA-Z]");
  if (!!pattern.test(value) || !value) {
    return true;
  } else {
    return "Please enter a valid url";
  }
};

const positiveRule = (value) => {
  if (!value || !value.toString().trim()) return true;
  if (!isNaN(value) && value >= 0) return true;
  return "The value should be numeric and greater than or equal to zero";
};

const notSpecialCharacters = (value) => {
  if (!/[^A-Za-z\d]/.test(value)) {
    return true;
  }
  return "Value must not contain special characters";
};

const __checkIpAddress = (value) => {
  const pattern = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
  if (pattern.test(value)) {
    const result = value
      .split(".")
      .map((x) => parseInt(x))
      .find((x) => x > 255 || x < 0);
    return !result;
  }
  return false;
};

const __checkHostname = (value) => {
  const pattern = /^[a-zA-Z\d][a-zA-Z\d-]+$/;
  return pattern.test(value);
};

const required = (value) => {
  if (Array.isArray(value)) {
    return !!value.length || "This field is required.";
  }
  return !!(value ?? "").toString().trim() || "This field is required.";
};

const requiredIf = (x) => {
  return (value) => {
    if (x) {
      return !!((value && value.toString()) || "").toString().trim() || "This field is required.";
    } else return true;
  };
};

const alphaNumeric = (value) => {
  const pattern = /^[\w_-]*$/;
  return pattern.test(value) || "Only Alpha Numeric.";
};

const hhMM = (value) => {
  const pattern = /^[0-2]\d:[0-5]\d$/;
  return pattern.test(value) || "Invalid Time Format. (HH:MM)";
};

const hhMmAA = (value) => {
  const pattern = /^((1[0-2])|(0?[0-9])):(([0-5][0-9])|(0[0-9])) (([AP]M)|([ap]m))$/;
  return pattern.test(value) || "Invalid Time Format. (HH:MM AM/PM)";
};

const spaceNotAllowed = (value) => {
  if (value?.includes(" ")) return "Space Not Allowed.";
  else return true;
};

const alphaNumericWithSpace = (value) => {
  const pattern = /^[\w\d\s_-]*$/;
  return pattern.test(value) || "No Special Characters Allowed.";
};

const noOnlyBlankSpace = (value) => !value || (value || "").trim() !== "" || "The value must not be blank.";
const mustTrim = (value) => !value || value === value.trim() || "Remove blank spaces at the start or end.";

const max15 = (value) => (value || "").trim().length <= 15 || "Maximum 15 characters.";
const max20 = (value) => (value || "").trim().length <= 20 || "Maximum 20 characters.";
const max25 = (value) => (value || "").trim().length <= 25 || "Maximum 25 characters.";
const max30 = (value) => (value || "").trim().length <= 30 || "Maximum 30 characters.";
const max40 = (value) => (value || "").trim().length <= 40 || "Maximum 40 characters.";
const max50 = (value) => (value || "").trim().length <= 50 || "Maximum 50 characters.";
const max80 = (value) => (value || "").trim().length <= 80 || "Maximum 80 characters.";
const max150 = (value) => (value || "").trim().length <= 150 || "Maximum 150 characters.";
const min5 = (value) => (value || "").trim().length >= 5 || "Minimum 5 characters required.";
const min8 = (value) => (value || "").trim().length >= 8 || "Minimum 8 characters required.";
const min4 = (value) => (value || "").trim().length >= 4 || "Minimum 4 characters required.";
const min6 = (value) => (value || "").trim().length >= 6 || "Minimum 6 characters required.";
const leadingZero = (value) => {
  const pattern = /^(0|0\.\d+|[1-9]\d*(\.\d+)?|[^0-9].*|[a-zA-Z].*)$/;
  return value ? pattern.test(value) || "Leading zero not allowed." : true;
};

const positiveNumber = (value) => (!isNaN(value) && value > 0) || "Positive Number Required.";

const notStartWithQuotes = (value) =>
  (!value?.startsWith("'") && !value?.startsWith("\"")) || "Quotes not allowed at start.";


const notEndWithQuotes = (value) =>
  (!value?.endsWith("'") && !value?.endsWith("\"")) || "Quotes not allowed at end.";

const maxNumber = (max) => (value) => {
  if (value)
    return (!isNaN(value) && parseInt(value) <= max) || `Value must be less or equal to ${max}.`;
  else return true;
};
const minNumber =
  (min, add = 0, sub = 0) =>
    (value) => {
      if (value)
        return (
          (!isNaN(value) && parseInt(value) >= (parseInt(min) || 0) + add - sub) ||
          `Value must be greater or equal to ${(parseInt(min) || 0) + add - sub}.`
        );
      else return true;
    };

const min = (count) => (value) =>
  (value || "").trim().length >= count || `Minimum ${count} characters required.`;

const max = (count) => (value) => {
  if (Array.isArray(value)) {
    const result = value.length <= count;
    if (result) {
      return true;
    }
    return `Maximum ${count} value required. `;
  }
  return (value || "").trim().length <= count || `Maximum ${count} value required. `;
};

const password = (value) => {
  value = value || "";
  if (value.trim().length < 8) return "Minimum 8 characters Password required.";
  if (!/[a-z]/gm.test(value)) return "Password must contain 1 lowercase(a-z).";
  if (!/[0-9]/gm.test(value)) return "Password must contain 1 digit(0-9)";
  return true;
};

const email = (value) => {
  const pattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/;
  if (Array.isArray(value)) {
    return !value.find((v) => !pattern.test(v)) || "Email  must be valid.";
  }
  return pattern.test(value) || "Email  must be valid.";
};

const url = (value) => {
  const pattern = /(\.|:)+[a-zA-Z\d].+/;
  return value ? pattern.test(value) || "Invalid Url." : true;
};

const onlyDigit = (value) => {
  const pattern = /^\+?\d+$/;
  return value ? pattern.test(value) || "Invalid Numbers." : true;
};

const simpleUrl = (value) => {
  if (
    value &&
    (value.toString().startsWith("http://") || value.toString().startsWith("https://"))
  ) {
    try {
      new URL(value);
      return value.trim().length > 10 || "Invalid Url.";
    } catch (error) {
      return "Invalid Url.";
    }
  }
  const pattern = /^([\w\d\-\/:]+\.)+[a-zA-Z][\/\w?=\-#&:]+/;
  return value ? pattern.test(value) || "Invalid Url." : true;
};

const urlWithIp = (value) => {
  if (value.trim().length === 0) return true;
  const regex = new RegExp(
    "^((?:https?://(?:www\\.)?|www\\.)(?:(?!-)[A-Za-z0-9-]+\\.[a-z]+)(?:\\/[A-Za-z0-9-_]+\\/?)*(?:[?&][A-Za-z0-9-\\=\\+_]+)*(?:\\.[a-z]+)*)$|^((?:\\d{1,3}\\.){3}\\d{1,3}(?:\\:\\d+)?)$",
    "gm"
  );

  let m;
  let found = false;

  while ((m = regex.exec(value)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }

    // The result can be accessed through the `m`-variable.
    m.forEach((match, groupIndex) => {
      found = true;
    });
  }

  return found ? true : "Invalid Url.";
};

const preventUderscore = (value) => {
  const pattern = /[_-]/;
  return !pattern.test(value) || "Special characters not allowed.";
};

const urlWithProtocol = (value) => {
  const pattern = /https?:\/\/([\w\d/:]+\.)+[a-zA-Z]{2,}[/\w?=\-#]+/;
  return pattern.test(value) || "Invalid Url. (protocol is missing)";
};

const httpAuthRule = (value) => {
  const pattern = /.+:.+/;
  return pattern.test(value) || "Invalid Http Auth. (username:password)";
};

const colonSeparateValue = (value) => {
  if (!value) return true;
  const pattern = /.+:.+/;
  return pattern.test(value) || "Invalid Value. (value:value)";
};

const colonSeparateMultipleValue = (value) => {
  if (!value) return true;
  const pattern = /[a-zA-Z0-9]+:[a-zA-Z0-9]+/;
  const valueArray = (value ?? "").split(",");
  const validValue = valueArray.filter((x) => pattern.test(x));
  return valueArray.length === validValue.length ? true : "Invalid Value (value:value)";
};

const port = (value) => {
  const pattern = /^\d{1,5}$/;
  if (pattern.test(value)) {
    value = parseInt(value);
    return value > 0 || value < 65354 || "Invalid Port Address.";
  }
  return "Invalid Port Address.";
};

const dbTable = (value) => {
  const pattern = /^[a-zA-Z_]\w+$/;
  return pattern.test(value) || "Invalid Name.";
};

const ip = (value) => {
  if (value?.length > 0) {
    if (Array.isArray(value)) {
      if (value.find((x) => !__checkIpAddress(x))) {
        return "Invalid Ip Address.";
      }
      return true;
    }
    return __checkIpAddress(value) || "Invalid Ip Address.";
  }
  return true;
};

const hostname = (value) => {
  return __checkHostname(value) || "Invalid HostName.";
};

//spaceRule: (value) => !(value || '').includes(' ') || 'Space is not Allowed',

const spaceRule = (value) => {
  if (value) {
    const pattern = /\s/;
    return !pattern.test(value) || "Space is not Allowed";
  }
  return true;
};

const variableName = (value) => {
  const pattern = /^[a-zA-Z_][a-zA-Z\d-_]*$/;
  return pattern.test(value) || "Invalid Name.";
};

const ipOrHost = (value) => {
  return /^\d/.test(value) ? ip(value) : hostname(value);
};

const environmentManagement = (value) => {
  if (value) {
    const pattern = /^.+::.+$/;
    return pattern.test(value) || "Invalid Url Override. (<value>::<value>)";
  }
  return true;
};
// ^[a-zA-Z][a-zA-Z0-9_-]*$
const slackName = (value) => {
  if (value) {
    const pattern = /^#[a-z0-9-/][a-z0-9-/]{0,150}$/;
    // const pattern = /^[a-zA-Z][a-zA-Z0-9_-]*$/;
    return pattern.test(value) || "Invalid Channel Name.";
  }
  return true;
};
const unique = (array) => (value) =>
  array.filter((x) => x === value).length === 1 || "Already exists.";

const distinctCaseInsentive = (array) => (value) => !array.find((x) => x.toLowerCase
  () === value.toLowerCase()
) || "Already exists.";

const distinct = (array) => (value) => !array.find((x) => x === value) || "Already exists.";

const match = (x) => (y) => x === y || "Does not match.";

const uniqueWithBlank = (array) => (value) =>
  array.filter((x) => Boolean(x)).filter((x) => x === value).length < 2 || "Already exists.";

const noSpace = (value) => {
  if (Array.isArray(value) && value.length > 0) {
    const result = value.find((x) => x.toString().includes(" "));
    if (result) return "Space not allowed.";
  }
  if (value && value.toString().includes(" ")) return "Space not allowed.";
  return true;
};

const spaceOnlyBetween = (value) => {
  if (value && (value.toString().startsWith(" ") || value.toString().endsWith(" ")))
    return "Space not allowed.";
  else return true;
};

const fileRequired = (v) => !!v || "File is required";

const ipPortArray = (val) => {
  let value = val.split(",").filter((x) => x.trim().length > 0);
  if (Array.isArray(value)) {
    const result = value.find((item) => {
      let value = item.split(":");
      if (value.length !== 2) return true;
      else {
        if (__checkIpAddress(value[0]) === true && port(value[1]) === true) {
        } else {
          return "Invalid Port or Ip Address.";
        }
      }
    });
    if (result) return "invalid value";
  }
  return true;
};

const ipAndPort = (val) => {
  const verify = (text) => {
    let value = (text ?? "").split(":");
    if (value.length !== 2) return "Invalid Ip Address and Port.";
    else {
      return (__checkIpAddress(value[0]) && port(value[1])) || "Invalid Ip Address.";
    }
  };

  if (val) {
    if (Array.isArray(val)) {
      const result = val.map((x) => verify(x)).filter((x) => x !== true);
      if (result.length) return result[0];
    } else {
      return verify(val);
    }
  }
  return true;
};

const urlArray = (val) => {
  let value = val.split(",");
  if (Array.isArray(value)) {
    const pattern = /^([\w\d\-\/:]+\.)+[a-zA-Z][\/\w?=\-#&:]+/;

    const result = value.find((item) => !pattern.test(item));
    if (result) return "Url is invalid";
  }
  return true;
};

const specialCharValueCheck = (value) => {
  const pattern = /^[a-z\d\-_]+$/i;
  return pattern.test(value) || "Special characters not allowed.";
};

const liveDebugRequired = (value) =>
  !!((value && value.toString()) || "").toString().trim() || "Please select at least 1 browser.";


const notEqualTo = (x) => (y) => x !== y || "Value should not be equal to : " + x;

export default {
  v_rule: {
    notEmptyRule,
    integersRule,
    positiveRule,
    notSpecialCharacters,
    urlArray,
    ipPortArray,
    notStartWithQuotes,
    notEndWithQuotes,
    required,
    noOnlyBlankSpace,
    mustTrim,
    min5,
    min8,
    max20,
    email,
    max15,
    max25,
    max30,
    max40,
    max50,
    url,
    unique,
    ip,
    port,
    dbTable,
    hostname,
    ipOrHost,
    max80,
    uniqueValue,
    urlWithProtocol,
    min,
    alphaNumeric,
    preventUderscore,
    onlyDigit,
    httpAuthRule,
    uniqueWithBlank,
    distinct,
    distinctCaseInsentive,
    match,
    fileRequired,
    variableName,
    spaceRule,
    min4,
    min6,
    max,
    password,
    alphaNumericWithSpace,
    noSpace,
    positiveNumber,
    maxNumber,
    minNumber,
    environmentManagement,
    colonSeparateValue,
    colonSeparateMultipleValue,
    max150,
    spaceNotAllowed,
    simpleUrl,
    urlWithIp,
    slackName,
    ipAndPort,
    specialCharValueCheck,
    spaceOnlyBetween,
    requiredIf,
    liveDebugRequired,
    hhMM,
    hhMmAA,
    leadingZero,
    nonNumberUrlRule,
    notEqualTo,
    dnsOverrideRule
  }
};
